export default __webpack_public_path__ + "media/color/colx-47ffed3a.svg";